import { params } from '@didi/driver-biz-sdk'
import { useRouter, useRoute } from '@/router/helper'

export function entryHandler(): void {
  const urlParams = params.urlParams
  const entry = urlParams.entry
  const nowRoute = useRoute().name
  if (typeof entry === 'string' && !nowRoute) {
    const router = useRouter()
    router.replace({
      name: entry
    })
  }
}
